/* global requirejs */
import { getConfiguration } from "./bagConfiguration";
import clientConfig from "../../template/clientConfig";
import emitter from "../../helpers/events";
import log from "../../helpers/logger";
import promiseWithTimeout from "../../helpers/promiseWithTimeout";

export const initialise = context =>
  new Promise(resolve =>
    requirejs(["bagSdk/sdk"], sdk =>
      resolve(sdk.getInstance(context, getConfiguration()))
    )
  );

export const waitForBagSDK = () =>
  new Promise((resolve, reject) => {
    if (clientConfig.isServer()) {
      return reject();
    }

    if (window.asos && window.asos.sdk && window.asos.sdk.bag) {
      resolve(window.asos.sdk.bag);
    } else {
      emitter.addListener("bag-sdk-ready", resolve);
    }
  });

export const getBagSummary = () =>
  waitForBagSDK()
    .then(bag => bag.getBagSummary())
    .catch(/* istanbul ignore next */ log.error);

export const removeItem = (itemId, itemType) =>
  waitForBagSDK().then(bag =>
    promiseWithTimeout(bag.removeItem(itemId, itemType))
  );

export const getBag = () =>
  waitForBagSDK()
    .then(bag => bag.getBag())
    .catch(/* istanbul ignore next */ log.error);

export const subscribeToUpdates = callback =>
  waitForBagSDK()
    .then(bag => {
      //eslint-disable-next-line no-undef
      $(bag).on("bagUpdated:completed", (...args) => {
        const { bag, messages } = args[2];
        callback({ bag, messages });
      });
    })
    .catch(/* istanbul ignore next */ log.error);

export const startCheckout = () =>
  waitForBagSDK()
    .then(bag => bag.startCheckout())
    .catch(/* istanbul ignore next */ log.error);



// WEBPACK FOOTER //
// ./client/sdk/bag.js